import "odometer/themes/odometer-theme-default.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/App.css';
import './src/styles/mobile.css';
import './src/styles/custom.scss';
import React from 'react';
import { AnalyticsProvider } from '@propriety/analytics';

export const wrapPageElement = ({ element, props }) => (
    <AnalyticsProvider 
        {...props}
        mixpanelToken="499d93415a9cc25c31017222ad6b73d2"
        trackingDomain="www.aventineproperties.com"
    >
        {element}
    </AnalyticsProvider>
);
